// extracted by mini-css-extract-plugin
export default {"moreButtonContainer":"Mi4D9","moreButton":"Mvyk+","openButton":"Dcih9","arrow":"yDgCA","arrowUp":"_3II2f","actionText":"gzokF","dropdown":"t-nR4"};